import { safeJson } from '@/scripts/utils';
import { msgExpireDurationOptions } from '@/configs/options';
import SysText from '../sysText';

const DestroyExpireDuration = ({
  payload,
  noStyle,
}: {
  payload: string;
  noStyle?: boolean;
}) => {
  const { user_name, expire_duration } = safeJson(payload, {} as any);
  const expireDuration = msgExpireDurationOptions.findByValue(expire_duration);
  return (
    <SysText noStyle={noStyle}>
      <Trans
        i18nKey="messages.chat.message.notice.expireDuration"
        values={{ name: user_name, tag: expireDuration?.tag }}
        components={{ name: <a /> }}
      ></Trans>
    </SysText>
  );
};

export default DestroyExpireDuration;
